import { render } from "./InstagramProfile.vue?vue&type=template&id=72d69d6a"
import script from "./InstagramProfile.vue?vue&type=script&lang=js"
export * from "./InstagramProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__